import type { EncounterFeeGate, QueueEntry } from '@his/shared';
import { ApiError } from '@/lib/api';

export function isFeeGate(error: unknown): boolean {
  return error instanceof ApiError && error.status === 409 && error.details.some((detail) => detail.path === 'feeOverrideReason');
}

export interface CloseGate {
  needsPayment: boolean;
  mayOverride: boolean;
}

export function closeGateFor(feeGate: EncounterFeeGate | null | undefined, holdsOverride: boolean): CloseGate {
  const needsPayment = feeGate?.mode === 'block' && !feeGate.settled;
  return { needsPayment, mayOverride: needsPayment && holdsOverride };
}

export function feeBannerFor(feeGate: EncounterFeeGate | null | undefined, status: string): 'warn' | 'block' | null {
  if (!feeGate || feeGate.settled || feeGate.mode === 'off' || status === 'closed') return null;
  return feeGate.mode;
}

export interface FeeWatch {
  doctorId: string;
  appointmentId: string;
}

export function feeWatchOf(
  encounter: { status: string; appointmentId?: string | null; doctor: { id: string }; feeGate?: EncounterFeeGate | null } | undefined,
): FeeWatch | null {
  if (!encounter?.appointmentId || encounter.status === 'closed') return null;
  const gate = encounter.feeGate;
  if (!gate || gate.settled || gate.mode === 'off') return null;
  return { doctorId: encounter.doctor.id, appointmentId: encounter.appointmentId };
}

const UNPAID_WITH_A_BILL = new Set(['due', 'insured_due']);

export function unpaidWithDoctor(rows: readonly Pick<QueueEntry, 'status' | 'feeState' | 'feeGate'>[]): number {
  return rows.filter((row) => row.status === 'in_consultation' && row.feeGate !== undefined && row.feeGate !== 'off' && UNPAID_WITH_A_BILL.has(row.feeState ?? '')).length;
}
